module.exports = "https://cdn-assessment.mathletics.com/app/119/assets/fonts/19b29984d782b315838f127af8295dde.woff2";